import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { appointmentQKeys } from "@hooks/queries/appointment/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


export const useDeleteAppointmentSlot = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (id: string) => {
      return api.delete(`appointments/v-slots/${id}`);
    },
    onSuccess: () => {
      showSuccessNotification({ message: "delete-appointment-slot-success" });
      queryClient.invalidateQueries({ queryKey: appointmentQKeys.slots() });
    },

    onError: (res: any) => {
      console.error("[From Delete Appointment Slot]", res);
      queryClient.invalidateQueries({ queryKey: appointmentQKeys.slots() });

      handleErrors(res, "mutation");
    },
  });
};
